export function normalizeBarcode(value?: string | number | null): string {
  if (!value) return '';

  const digitsOnly = String(value).replace(/\D/g, '');
  if (!digitsOnly) return '';

  const withoutLeadingZeroes = digitsOnly.replace(/^0+/, '');
  return withoutLeadingZeroes || '0';
}
